import React from 'react';
import OpenPreviewProductDetail from '../../../../../containers/app/common/OpenPreviewProductDetail';
import OpenOrderDeliveryTracking from '../../../../../containers/app/common/OpenOrderDeliveryTracking';
import SendMessageService from '../../../../../containers/app/common/SendMessageService';
import OpenCsInquiryQuestion from '../../../../../containers/cs/inquiry/common/OpenCsInquiryQuestion';
import OpenBrandDetail from '../../../../../components/link/OpenBrandDetail';
import OpenProductDetail from '../../../../../components/link/OpenProductDetail';
import OpenOrderItemDetail from '../../../../../components/link/OpenOrderItemDetail';
import OpenUserDetail from '../../../../../components/link/OpenUserDetail';
import TableColumnImg from '../../../../../components/table/TableColumnImg';
import Anchor from '../../../../../components/link/Anchor';
import {
  setColumnWidth,
  setDash,
  setDetailPageUrl,
  setPhoneFormat,
  setNumberWithComma,
} from '../../../../../lib/common';
import { setDateFormat } from '../../../../../lib/moment';
import { AMONDZ_MEMBER_TYPE, DATE_FORMAT } from '../../../../../constants/service/common/utilConstants';
import {
  ORDER_DELIVERY_TYPE,
  ORDER_DELIVERY_TYPE_TEXT,
  ORDER_ITEM_STATUS,
  ORDER_ITEM_STATUS_TEXT,
  PAY_METHOD_TYPE_TEXT,
} from '../../../../../constants/service/app/orderConstants';
import {
  CS_INQUIRY_RESPONSE_STATUS_TEXT,
  CS_INQUIRY_TYPE_TEXT,
} from '../../../../../constants/service/app/csInquiryConstants';
import { CS_INQUIRY_DETAIL_URL_PATH } from '../../../../../constants/service/common/urlConstants';

/**
 *  1:1 문의 최근 주문서 내용 컬럼
 */
export const latestOrderColumns = () => {
  return [
    {
      accessor: 'orderId',
      Header: '주문번호',
      fixed: 'left',
      width: 150,
    },
    {
      accessor: 'orderItemId',
      Header: '상품 주문번호',
      fixed: 'left',
      width: 150,
      Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
    },
    {
      accessor: 'storeName',
      Header: '브랜드명',
      width: 150,
      Cell: (row) => <OpenBrandDetail text={`${row.value}(${row.original.storeId})`} storeId={row.original.storeId} />,
    },
    {
      accessor: 'storePhone',
      Header: '브랜드 연락처',
      width: 130,
      Cell: (row) => setPhoneFormat(row.value),
    },
    {
      accessor: 'asPhone',
      Header: 'AS 전화번호',
      width: 130,
      Cell: (row) => setPhoneFormat(row.value),
    },
    {
      accessor: 'sellerAccount',
      width: 160,
      Header: '판매자 계정',
    },
    {
      accessor: 'sellerName',
      Header: '판매자명',
      width: 150,
      Cell: (row) => `${row.value}(${row.original.sellerId})`,
    },
    {
      accessor: 'sellerPhone',
      Header: '판매자 연락처',
      width: 130,
      Cell: (row) => (
        <SendMessageService
          text={setPhoneFormat(row.value)}
          memberType={AMONDZ_MEMBER_TYPE.SELLER}
          targetId={row.original.storeId}
        />
      ),
    },
    {
      accessor: 'deliveryType',
      Header: '배송방법',
      Cell: (row) => ORDER_DELIVERY_TYPE_TEXT[row.value] || '_',
    },
    {
      accessor: 'deliveryEnterprise',
      Header: '택배사',
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'invoiceNumber',
      Header: '송장 번호',
      Cell: (row) => setDash(row.value),
    },
    {
      Header: '배송 추적',
      Cell: (row) => {
        /**
         *  상품 주문 상태가 배송 중/배송 완료이며, 택배방법이 [택배, 등기, 소포]일 경우에만 추적 활성화
         */
        if (
          (row.original.orderItemStatus === ORDER_ITEM_STATUS.SHIPPING ||
            row.original.orderItemStatus === ORDER_ITEM_STATUS.DELIVERY_COMPLETE) &&
          row.original.deliveryType === ORDER_DELIVERY_TYPE.PARCEL_DELIVERY
        )
          return <OpenOrderDeliveryTracking deliveryId={row.original.deliveryId} />;
        else return setDash(row.value);
      },
    },
    {
      accessor: 'orderItemStatus',
      Header: '상품 주문 상태',
      Cell: (row) => ORDER_ITEM_STATUS_TEXT[row.value] || '_',
    },
    {
      accessor: 'orderDate',
      Header: '주문 일시',
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
    },
    {
      accessor: 'paymentDate',
      Header: '결제 일시',
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
    },
    {
      accessor: 'deliveryPrepareDate',
      Header: '상품 준비 일시',
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
    },
    {
      accessor: 'deliveryDispatchDate',
      Header: '발송 처리 일시',
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
    },
    {
      accessor: 'deliveryCompleteDate',
      Header: '배송 완료 일시',
      width: 140,
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_HM_DASH_FORMAT),
    },
    {
      accessor: 'productId',
      Header: '상품번호',
      Cell: (row) => <OpenProductDetail text={row.value} productId={row.value} />,
    },
    {
      accessor: 'productName',
      Header: '상품명',
      className: 'align-left',
      resizable: true,
      width: 150,
      Cell: (row) => <OpenPreviewProductDetail text={row.value} productId={row.original.productId} />,
    },
    {
      accessor: 'productOptionName',
      Header: '옵션정보',
      resizable: true,
      width: 150,
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'quantity',
      Header: '수량',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'productOriginalPrice',
      Header: '상품 가격(정가)',
      width: 130,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'productDiscountPrice',
      Header: '상품 할인액(차감된 금액)',
      width: 160,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'productOptionPrice',
      Header: '옵션 가격',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'usedCoupon',
      Header: '쿠폰',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'usedPoint',
      Header: '포인트',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'totalPrice',
      Header: '상품별 총 주문금액',
      width: 150,
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'deliveryExtraFee',
      Header: '추가 배송비',
      Cell: (row) => setNumberWithComma(row.value),
    },
    {
      accessor: 'buyerPhone',
      Header: '구매자 연락처',
      width: 130,
      Cell: (row) => (
        <SendMessageService
          text={setPhoneFormat(row.value)}
          memberType={AMONDZ_MEMBER_TYPE.USER}
          targetId={row.original.userId}
        />
      ),
    },
    {
      accessor: 'recipientPhone',
      Header: '수취인 연락처',
      width: 130,
      Cell: (row) => (
        <SendMessageService
          text={setPhoneFormat(row.value)}
          memberType={AMONDZ_MEMBER_TYPE.RECIPIENT}
          targetId={row.original.orderItemId}
        />
      ),
    },
    {
      accessor: 'recipientName',
      Header: ' 수취인명',
    },
    {
      accessor: 'address',
      Header: '배송지',
      resizable: true,
      width: 250,
    },
    {
      accessor: 'postCode',
      Header: '우편번호',
    },
    {
      accessor: 'message',
      Header: '배송 메시지',
      resizable: true,
      width: 200,
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'payMethod',
      Header: '결제수단',
      width: 130,
      Cell: (row) => PAY_METHOD_TYPE_TEXT[row.value] || '_',
    },
  ];
};

/**
 *  1:1 문의 유저의 다른 문의 내역 조회하기
 */
export const usersOtherInquiryColumns = (data) => {
  const { list } = data;

  return [
    {
      accessor: 'isResponse',
      Header: '답변 처리',
      fixed: 'left',
      width: 120,
      Cell: (row) => (
        <Anchor
          text={CS_INQUIRY_RESPONSE_STATUS_TEXT[row.value]}
          isUnderLine
          color="primary"
          href={setDetailPageUrl(CS_INQUIRY_DETAIL_URL_PATH, row.original.id)}
          target="_blank"
        />
      ),
    },
    {
      accessor: 'orderItemId',
      Header: '주문여부',
      fixed: 'left',
      width: 120,
      Cell: (row) => <OpenOrderItemDetail text={row.value} orderItemId={row.value} />,
    },
    {
      accessor: 'orderItemStatus',
      Header: '주문상태',
      fixed: 'left',
      width: 120,
      Cell: (row) => setDash(ORDER_ITEM_STATUS_TEXT[row.value]),
    },
    {
      accessor: 'type',
      Header: '질문 유형',
      fixed: 'left',
      width: 170,
      Cell: (row) => CS_INQUIRY_TYPE_TEXT[row.value] || '_',
    },
    {
      accessor: 'buyerId',
      Header: '구매자 ID',
      resizable: true,
      fixed: 'left',
      width: setColumnWidth(list, 'buyerId'),
      Cell: (row) => <OpenUserDetail text={row.value} userId={row.original.userId} />,
    },
    {
      accessor: 'url',
      Header: '이미지',
      Cell: (row) => <TableColumnImg url={row.value} />,
    },
    {
      accessor: 'question',
      Header: '질문 내용',
      className: 'align-left',
      width: 200,
      resizable: true,
      Cell: (row) => (
        <OpenCsInquiryQuestion
          text={row.value}
          question={row.value}
          answer={row.original.answer}
          memo={row.original.memo}
        />
      ),
    },
    {
      accessor: 'answer',
      Header: '답변 내용',
      className: 'align-left',
      width: 200,
      resizable: true,
      Cell: (row) => (
        <OpenCsInquiryQuestion
          text={row.value}
          question={row.original.question}
          answer={row.value}
          memo={row.original.memo}
        />
      ),
    },
    {
      accessor: 'replyAuthor',
      Header: '답변 작성자',
      width: setColumnWidth(list, 'replyAuthor'),
      Cell: (row) => setDash(row.value),
    },
    {
      accessor: 'memo',
      Header: '답변 작성자 메모',
      className: 'align-left',
      resizable: true,
      width: 200,
      Cell: (row) => (
        <OpenCsInquiryQuestion
          text={row.value}
          question={row.original.question}
          answer={row.original.answer}
          memo={row.value}
        />
      ),
    },
    {
      accessor: 'answerDate',
      Header: '답변 일자',
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.YMD_DASH_FORMAT),
    },
    {
      id: 'createDate',
      accessor: 'createDate',
      Header: '질문 작성 일자',
      Cell: (row) => setDateFormat(row.value, DATE_FORMAT.FULL_DASH_FORMAT),
    },
  ];
};
